import React, { useEffect, useState } from "react";
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Typography, Box, TextField, Button, Chip, Stack } from "@mui/material";
import { getActionTypes } from "../../api";

const ActionTypeSelection = ({ selectedActions, setSelectedActions }) => {
  const [actions, setActions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchActions = async () => {
      try {
        const response = await getActionTypes();
        setActions(response.data.data);
      } catch (error) {
        console.error("Error fetching actions:", error);
      }
    };

    fetchActions();
  }, []);

  const handleAdd = (sensor) => {
    setSelectedActions((prev) => [...prev, sensor]);
  };

  const handleRemove = (index) => {
    setSelectedActions((prev) => prev.filter((_, i) => i !== index));
  };

  const filteredActions = actions.filter((action) => action.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <Box>
      <Typography variant="h6">Select Actions For Entity</Typography>
      <TextField label="Search Actions" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">Selected Sensors:</Typography>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", mt: 1 }}>
          {selectedActions
            .map((action, index) => (
              <Chip key={index} label={`${action.name} (${index + 1})`} onDelete={() => handleRemove(index)} sx={{ mb: 1 }} />
            ))}
        </Stack>
      </Box>
      <Box
        sx={{
          maxHeight: 300,
          overflowY: "auto",
          border: "1px solid #ccc",
          borderRadius: 1,
          p: 1,
        }}
      >
        <List>
          {filteredActions.map((action) => (
            <ListItem key={action._id} alignItems="flex-start">
              <Box sx={{ marginRight: 2 }}>
                <img
                  src={action.imageUrl}
                  alt={action.name}
                  style={{
                    width: "80px", // Adjust the width as needed
                    height: "80px", // Adjust the height as needed
                    borderRadius: "8px", // Optional, for rounded corners
                    objectFit: "cover", // Ensures the image maintains aspect ratio
                  }}
                />
              </Box>
              <ListItemText
                primary={<Typography variant="subtitle1">{action.name}</Typography>}
                secondary={
                  <>
                    <Typography variant="body2" color="textSecondary">
                      {action.description}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {action.type}
                    </Typography>
                  </>
                }
              />
              <Button variant="contained" size="small" onClick={() => handleAdd(action)}>
                Add
              </Button>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default ActionTypeSelection;
